import type { AppSettingsType, SettingsParamsType } from '@econtractor/types';
import { normalizeSettingsParams } from 'components/Settings/MainSettings/model/defaults';

export const getSettingsParams = (
    settings?: Pick<AppSettingsType, 'global'> | null,
): SettingsParamsType => normalizeSettingsParams(settings?.global?.params);
